import { CSSProperties } from 'react'
import styled from 'styled-components'

export const XTick = ({
  x,
  y1,
  y2,
  style,
  label,
}: {
  x: number
  y1: number
  y2: number
  style?: CSSProperties
  label?: number
}) => {
  return (
    <>
      {(label || label === 0) && (
        <TickText x={x + 5} y={28}>
          {label}
        </TickText>
      )}
      {label && label > 0 && (
        <TickLine x1={x + 1} x2={x + 1} y1={y1} y2={y2} style={style} />
      )}
    </>
  )
}

const TickLine = styled.line`
  stroke: var(--text-color);
  opacity: 0.5;
`
const TickText = styled.text`
  font-size: 12px;
  fill: var(--text-color);
  opacity: 0.75;
`
